import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { TokenService } from '../services/token.service';
import { CoreService } from '../services/core.service';
import { PatientService } from '../services/patient.service';
import { firstValueFrom } from 'rxjs';
import { ADMIN_ROLES, PATIENT_ROLES } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override router: Router,
    protected override keycloakAngular: KeycloakService,
    private readonly tokenService: TokenService,
    private settings: CoreService,
    private patientService: PatientService,
  ) {
    super(router, keycloakAngular);
  }

  isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      if (!this.authenticated) {
        await this.keycloakAngular.login();
        return resolve(false);
      }

      console.log(this.roles);
      const allAdminRolesMissing = this.roles.every(
        (str) => !ADMIN_ROLES.includes(str)
      );
      const isPatientRolesPresent = this.roles.some((str) =>
        PATIENT_ROLES.includes(str)
      );
      
      if (isPatientRolesPresent || allAdminRolesMissing) {
        const username = this.keycloakAngular.getKeycloakInstance().tokenParsed?.['preferred_username'];
        const patient = await firstValueFrom(this.patientService.getPazienteByCf(username));
        
        if (patient.ehrId) {
          if (this.patientService.getSelectedPatient()) {
            return resolve(true);
          }
          this.patientService.selectPatient(patient);
          this.router.navigateByUrl('/military/' + patient.ehrId + '/dossier/personal-data');
          return resolve(true);
        } else {
          console.error("Nessun ehrId configurato sull'utenza");
        }
        return resolve(false);
      }

      const requiredRoles = route.data['roles'];
      if (!requiredRoles || requiredRoles.length === 0) {
        return resolve(true);
      } else {
        const hasRole = requiredRoles.every((role: string) =>
          this.roles.includes(role)
        );
        return resolve(hasRole);
      }
    });
  }

  async getEhrIdFromToken(): Promise<string | null> {
    const tokenParsed: any =
      this.keycloakAngular.getKeycloakInstance().tokenParsed;

    if (tokenParsed?.attributes?.ehrId) {
      return tokenParsed.attributes.ehrId[0];
    }

    return null;
  }
}
